import { useMutation } from "react-query";
import Axios from "axios";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { ResourceInactivityResponseDto } from "../../../features/Schedule/typings/resource-calendar.types";

export type ResourceInactivityByObjectParams = {
  bookingType: BookingType;
  bookingInventoryId: number;
  startDate: string;
  endDate: string;
};

export function useRemoteResourceInactivityByBookingObjectMutation() {
  return useMutation({
    mutationFn: async (
      params: ResourceInactivityByObjectParams
    ): Promise<ResourceInactivityResponseDto> => {
      const { data } = await Axios.get<ResourceInactivityResponseDto>(
        "/booking-schedule/inactivity-by-booking-object",
        { params }
      );
      return data;
    }
  });
}
